module.exports = __webpack_public_path__ + "5f467640f99239991d453c4937e31f9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201509_sk.jpg
// module id = 638
// module chunks = 0